import {
  AXIOS_START,
  AXIOS_END,
  AXIOS_RESET,
  SAVE_TOKEN,
  CLEAR_TOKEN
} from './mutation-types'
import {
  reqSendCode,
  reqNewSendCode,
  reqResetCode,
  reqSmsLogin,
  reqRegLogin,
  reqPwdReset,
  reqResetSubmit,
  pwdloginapi,
  registerapi,
  reqLogout,
  reqSendLoginCode
} from '@/api/user'

const state = {
  axios: [],
  token: null
}

const mutations = {
  // 异步请求开始
  [AXIOS_START](state, name) {
    state.axios.push(name)
  },
  // 异步请求结束
  [AXIOS_END](state, name) {
    const index = state.axios.indexOf(name)
    index >= 0 && state.axios.splice(index, 1)
  },
  // 异步请求重置
  [AXIOS_RESET](state) {
    state.axios = []
  },
  // 保存token
  [SAVE_TOKEN](state, token) {
    state.token = token
  },
  // 清除token
  [CLEAR_TOKEN](state) {
    state.token = null
  }
}

const actions = {
  // 发送短信验证码
  async sendCode({ commit }, { phone, callback }) {
    if (undefined !== await reqSendCode(phone)) {
      callback && callback()
    }
  },

  async sendLoginCode({ commit }, { phone, callback }) {
    if (undefined !== await reqSendLoginCode(phone)) {
      callback && callback()
    }
  },

  // 发送短信验证码
  async newSendCode({ commit }, { phone, callback }) {
    var yuming = window.location.protocol+"//"+window.location.host+""+window.location.pathname;
    var url = yuming + window.localStorage.getItem("paramsurl");
    console.log("source",url);
    if (undefined !== await reqNewSendCode(phone, url)) {
      callback && callback()
    }
  },
  // 发送短信验证码
  async resetCode({ commit }, callback) {
    if (undefined !== await reqResetCode()) {
      callback && callback()
    }
  },
  // 重置密码
  async resetSubmit({ commit }, { password, password_confirmation, code, callback }) {
    if (undefined !== await reqResetSubmit(password, password_confirmation, code)) {
      callback && callback()
    }
  },
  // 重置密码
  async pwdReset({ commit }, { phone, password, code, callback }) {
    if (undefined !== await reqPwdReset(phone, password, code)) {
      callback && callback()
    }
  },
  // 注册并登录
  async regLogin({ commit }, { phone, pwd,pwd2, code, callback }) {
    const data = await registerapi({phone, pwd,pwd2, code});
    if(data.code == 200){
        localStorage.setItem('token',data.data.token);
        callback && callback()
    } 
  },
  // 验证码登陆
  async smsLogin({ commit }, { phone, code, callback }) {
    const data = await reqSmsLogin(phone, code)
    if (undefined !== data) {
      localStorage.setItem('token',data.data.token);
      callback && callback()
    }
  },
  // 账号密码登陆
  async pwdLogin({ commit }, { phone, pwd, callback }) {
    const data = await pwdloginapi({phone, pwd})
    if(data.code == 200){
        localStorage.setItem('token',data.data.token);
        callback && callback()
    } 
  },
  // 用户登出
  async logout({ commit }, callback) {
    localStorage.removeItem('token');
    callback && callback()
  }
}

const getters = {
  // 返回是否处于axios状态
  loading(state) {
    return state.axios.length > 0
  }
}

export default { state, mutations, actions, getters }